// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6f81e5f5","732":"21f7344e","977":"848982ac"}[chunkId] + ".chunk.js";
};